import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from "@material-ui/core/FormControl";

// @material-ui/icons
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
import Assignment from "@material-ui/icons/Assignment";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Clearfix from "components/Clearfix/Clearfix.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import Subscriptions from "views/Components/Subscriptions"
import PmsSearch from "views/Components/PmsSearch"
import Agreement from "views/Pages/SignupSteps/Agreement"
import Payment from "views/Pages/SignupSteps/Payment"

import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import Danger from "components/Typography/Danger.jsx";

import axios from 'axios';
import { API_ROOT, CREDIT_CARD_PROCESSOR } from 'api-config';
import { getApiHeaders } from '../../assets/helpers/apiHelper.jsx';
import { verifyNumber, verifyEmail, verifyLength, verifyZip, verifyPhone } from '../../assets/helpers/formHelper.jsx';
import {
  cirrusOrangeColor
} from "assets/jss/material-dashboard-pro-react.jsx";
import { parsePhoneResponse, formatPhoneNumber } from "../../assets/helpers/apiHelper";

const usStateList = require('../../assets/selectLists/usStates.json');
const nameLength = 2;
const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  choiche: {
    textAlign: "center",
    cursor: "pointer",
    marginTop: "20px"
  },
  cardCategory: {
    color: "#999999",
    marginTop: "10px"
  },
  icon: {
    color: "#333333",
    margin: "10px auto 0",
    width: "130px",
    height: "130px",
    border: "1px solid #E5E5E5",
    borderRadius: "50%",
    lineHeight: "174px",
    "& svg": {
      width: "55px",
      height: "55px"
    },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      width: "55px",
      fontSize: "55px"
    }
  },
  iconcirrusOrange: {
    color: cirrusOrangeColor
  },
  marginTop30: {
    marginTop: "30px"
  },
  subscriptionDetails: {
    margin: "25px",
    padding: "15px",
    width: "300px",
    height: "300px",
    overflow: "auto"
  },
  ...userProfileStyles,
  ...regularFormsStyle
};



class RegisterPatient extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false;
    this.onSubmitRegistration = this.onSubmitRegistration.bind(this);

    var asPopup = false
    var parentPatientId = ''
    var parentOrgType = ''
    var registerAsChild = false
    var userAgreementSubheader = "select how to send the user agreement for signing (required)"
    var providerId = sessionStorage.getItem('userId')
    var editByOrg = true
    var viewType = ''
    var routingNumberState = ''
    var accountNumberState = ''
    var agreeState = ''
    var agree = ''
    var employerId = ''
    var actorOrgType = ''
    var inDialog = false;
    var formControlMargin = 'none'
    var customInputStyle = ''
    var acceptCreditCards = ''
    var allowMonthlyPlans = ''
    var allowAnnualPlans = ''
    var getMemberPlanInfo = false
    if (props.asPopup) {
      asPopup = props.asPopup
    }
    if (props.actorOrgType) {
      actorOrgType = props.actorOrgType
    }
    if (props.viewType && props.viewType === 'patient') {
      parentPatientId = props.parentPatientId
      parentOrgType = 'M'
      userAgreementSubheader = 'sign the agreement on behalf of the new member'
    }
    if (props.registerAsChild) {
      registerAsChild = props.registerAsChild
    }
    if (props.providerId) {
      providerId = props.providerId
    }
    if (props.editByOrg) {
      editByOrg = false
    }
    if (props.viewType) {
      viewType = props.viewType
    }
    if (props.acceptCreditCards) {
      acceptCreditCards = props.acceptCreditCards
    }
    const chargeCreditCardFee = props.acceptCreditCards ? props.acceptCreditCards : '';
    const creditCardFee = props.creditCardFee ? props.creditCardFee : '';
    if (props.allowMonthlyPlans) {
      allowMonthlyPlans = props.allowMonthlyPlans
    }
    if (props.allowAnnualPlans) {
      allowAnnualPlans = props.allowAnnualPlans
    }

    if (viewType === 'employer') {
      routingNumberState = 'success'
      accountNumberState = 'success'
      agreeState = 'success'
      parentOrgType = 'E'
      providerId = ''
      agree = 'E'
      employerId = sessionStorage.getItem('userId')
      parentPatientId = props.parentPatientId
    }
    if (props.inDialog) {
      inDialog = props.inDialog
      formControlMargin = 'dense'
      customInputStyle = {marginTop: "24px"}
    }
    this.state = {
      providerId: providerId,
      firstName: '',
      firstNameState: '',
      lastName: '',
      lastNameState: '',
      address1: '',
      address2: '',
      addressCity: '',
      addressState: '',
      addressZip: '',
      addressZipState: '',
      email: '',
      emailState: '',
      usernameStatusMessage: '',
      phone: '',
      phoneState: '',
      cellphone: '',
      cellphoneState: '',
      routingNumber: '',
      routingNumberState: routingNumberState,
      accountNumber: '',
      accountNumberState: accountNumberState,
      accountType: '',
      paymentMethod: 'A',
      creditCardTxToken: '',
      creditCardProcessor: '',
      bankName: '',
      agree: agree,
      agreeState: agreeState,
      inputDisabled: false,
      registrationStatus: '',
      errorText: '',
      finishButtonDisabled: false,
      selectedPlanId: '',
      selectedPlanType: '',
      selectedPlanState: '',
      selectedSavingsAmount: 0,
      editByOrg: editByOrg,
      asPopup: asPopup,
      parentPatientId: parentPatientId,
      parentOrgType: parentOrgType,
      selectedProviderId: '',
      registerAsChild: registerAsChild,
      userAgreementSubheader: userAgreementSubheader,
      fullAgreementViewed: '',
      agreementFileName: '',
      viewType: viewType,
      employerId: employerId,
      actorOrgType: actorOrgType,
      inDialog: inDialog,
      formControlMargin: formControlMargin,
      customInputStyle: customInputStyle,
      acceptCreditCards: acceptCreditCards,
      chargeCreditCardFee: chargeCreditCardFee,
      creditCardFee: creditCardFee,
      allowMonthlyPlans: allowMonthlyPlans,
      allowAnnualPlans: allowAnnualPlans,
      getMemberPlanInfo: getMemberPlanInfo,
      pmsIntegration: false,
      pmsSearchOpen: false,
      pmsPatientId: ''
    }
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleChangeSelect = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  componentDidMount() {
    this._isMounted = true;

    this.setState({inputDisabled: false})

    if (this.state.parentPatientId !== '' && this.state.viewType === 'patient') {
      this.loadPatientRegistrationInfo()
    }
    if (this.state.providerId && this.state.parentOrgType !== 'M') {
      this.lookUpProviderSettings()
    }
    if (this.state.actorOrgType === 'provider') {
      this.checkForPmsIntegration()
    }

  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  loadPatientRegistrationInfo() {
    axios.get(`${API_ROOT}/user/?userId=`+this.state.parentPatientId, {headers: getApiHeaders()})
      .then(res => this.setUserValues({responseMessage: res.data}));

    axios.get(`${API_ROOT}/address/?userId=`+this.state.parentPatientId, {headers: getApiHeaders()})
      .then(res => this.setAddressValues({responseMessage: res.data}));

    axios.get(`${API_ROOT}/financialAccount/?userId=`+this.state.parentPatientId, {headers: getApiHeaders()})
      .then(res => this.setFinancialAccountValues({responseMessage: res.data}));

    axios.get(`${API_ROOT}/phone/?userId=`+this.state.parentPatientId, {headers: getApiHeaders()})
      .then(res => this.setPhoneValues({responseMessage: res.data}));

    axios.get(`${API_ROOT}/provider/?userId=`+this.state.parentPatientId+`&isPrimary=1`, {headers: getApiHeaders()})
      .then(res => this.setSelectedProvider({responseMessage: res.data}));

  }

  checkForPmsIntegration() {
    axios.get(`${API_ROOT}/connectedAccount/?userId=` + this.state.providerId + `&category=pms&boolean=true`, { headers: getApiHeaders() })
      .then(res => this.setPmsIntegration(res.data));
  }

  setPmsIntegration(res) {
    if (res['status']) {
      this.setState({
        pmsIntegration: true
      });
    }
  }

  togglePmsSearchOpen() {
    this.setState({
      pmsSearchOpen: !this.state.pmsSearchOpen
    });
  }

  setUserValues(userData) {
    if (this._isMounted) {
      if (!userData.responseMessage.error) {
        var emailState = ''
        if (verifyEmail(userData.responseMessage.email)) {
          emailState = 'success'
        }
        this.setState({
          email: userData.responseMessage.email,
          emailState: emailState
        });
      }
    }
  }

  setAddressValues(addressData) {
    if (this._isMounted) {
      if (!addressData.responseMessage.error) {

        var addressZipState = ''
        if (verifyZip(addressData.responseMessage.zip)) {
          addressZipState = 'success'
        }

        this.setState({
          address1: addressData.responseMessage.address1,
          address2: addressData.responseMessage.address2,
          addressCity: addressData.responseMessage.city,
          addressState: addressData.responseMessage.state,
          addressZip: addressData.responseMessage.zip,
          addressZipState: addressZipState
        });
      }
    }
  }

  setFinancialAccountValues(financialAccountData) {
    if (this._isMounted) {
      if (!financialAccountData.responseMessage.error) {
        var routingNumberState = ''
        var accountNumberState = ''
        if ((verifyNumber(financialAccountData.responseMessage.routingNumber) && verifyLength(financialAccountData.responseMessage.routingNumber, 9))) {
          routingNumberState = 'success'
        }

        if (verifyNumber(financialAccountData.responseMessage.accountNumber)) {
          accountNumberState = 'success'
        }

        this.setState({
          routingNumber: financialAccountData.responseMessage.routingNumber,
          accountNumber: financialAccountData.responseMessage.accountNumber,
          routingNumberState: routingNumberState,
          accountNumberState: accountNumberState,
          accountType: financialAccountData.responseMessage.accountType
        });
        if (routingNumberState === 'success') {
          this.getBankName()
        }
      }
    }
  }

  setPhoneValues(phoneData) {
    if (this._isMounted) {
      if (!phoneData.responseMessage.error) {
        var phoneState = ''
        var cellphoneState = ''
        const phoneArray = parsePhoneResponse(phoneData.responseMessage)
        if (verifyPhone(phoneArray['phone'])) {
          phoneState = 'success'
        }
        if (verifyPhone(phoneArray['cellphone'])) {
          cellphoneState = 'success'
        }
        this.setState({
          phone: phoneArray['phone'],
          cellphone: phoneArray['cellphone'],
          phoneState: phoneState,
          cellphoneState: cellphoneState
        });
      }
    }
  }

  setSelectedProvider(res) {
    var providerId = ''
    if (res.responseMessage.length > 0) {
      providerId = res.responseMessage[0]['userId']
    }
    this.setState({
      selectedProviderId: providerId
    });
  }


  //separate function to set the routing number state and get name
  //pass the routing number from the event (event.target.value) to getBankName
  //use passed number if it is there, otherwise use state.
  getBankName(routingNumber) {
    if (!routingNumber) {
      routingNumber = this.state.routingNumber;
    }
    if (routingNumber.length === 9) {
      axios.get(`${API_ROOT}/routingNumber/?routingNumber=` + routingNumber, { headers: getApiHeaders() })
        .then(res => this.setState({ bankName: res.data.customerName }));
    } else {
      this.setState({ bankName: '' })
    }
  }

  checkUniqueUsername(username) {
    axios.get(`${API_ROOT}/checkUser/?username=` + username, { headers: getApiHeaders() })
      .then(res => this.setUniqueUsername(res.data.message ));
  }

  setUniqueUsername(res) {
    if (this._isMounted) {
      if (res === 'username taken') {
        this.setState({
          emailState: "error",
          usernameStatusMessage: 'The username/email is already taken. Please enter a different email address.'
        });
      }
    }
  }


  selectPlan(planId, planType) {
    var planIdState = "error"
    if (planId) {
      planIdState = "success"
    }
    this.setState({
      selectedPlanId: planId,
      selectedPlanState: planIdState,
      selectedPlanType: planType
    });
  }

  selectSavingsAmount(savingsAmount) {
    this.setState({
      selectedSavingsAmount: savingsAmount
    })
  }

  change(event, stateName, type, stateNameEqualTo, emptyOkay) {
    if (emptyOkay && !event.target.value) {
      this.setState({ [stateName + "State"]: "" });
    } else {
      switch (type) {
        case "email":
          if (verifyEmail(event.target.value)) {
            this.setState({
              [stateName + "State"]: "success",
              usernameStatusMessage: ''
            });
            this.checkUniqueUsername(event.target.value)
          } else {
            this.setState({ [stateName + "State"]: "error" });
          }
          break;
        case "length":
          if (verifyLength(event.target.value, stateNameEqualTo)) {
            this.setState({ [stateName + "State"]: "success" });
          } else {
            this.setState({ [stateName + "State"]: "error" });
          }
          break;
        case "zip":
          if (verifyZip(event.target.value, stateNameEqualTo)) {
            this.setState({ [stateName + "State"]: "success" });
          } else {
            this.setState({ [stateName + "State"]: "error" });
          }
          break;
        case "phone":
          if (verifyPhone(event.target.value)) {
            this.setState({ [stateName + "State"]: "success" });
          } else {
            this.setState({ [stateName + "State"]: "error" });
          }
          break;
        case "routingNumber":
          if ((verifyNumber(event.target.value) && verifyLength(event.target.value, stateNameEqualTo)) ||
            event.target.value === '') {
            this.setState({ [stateName + "State"]: "success" });
            //if it is verified, also get the bank name
            this.getBankName(event.target.value);
          } else {
            this.setState({ [stateName + "State"]: "error" });
            this.setState({ bankName: '' })
          }
          break;
        case "number":
          if (verifyNumber(event.target.value) || (event.target.value === '' && !this.state.requireAccountNumber)) {
            this.setState({ [stateName + "State"]: "success" });
          } else {
            this.setState({ [stateName + "State"]: "error" });
          }
          break;
        case "accountType":
          if (event.target.value || !this.state.requireAccountType) {
            this.setState({ accountTypeState: "success" });
          } else {
            this.setState({ accountTypeState: "error" });
          }
          break;
        case "exists":
          if (event.target.value) {
            this.setState({ [stateName + "State"]: "success" });
          } else {
            this.setState({ [stateName + "State"]: "error" });
          }
          break;
        default:
          break;
      }
    }

    this.setState({ [stateName]: event.target.value });
  };
  isValidated() {
    if (
      this.state.firstNameState === "success" &&
      this.state.lastNameState === "success" &&
      (this.state.addressZipState === "success" || this.state.addressZipState === "") &&
      this.state.emailState === "success" &&
      (this.state.phoneState === "success" || this.state.phoneState === "") &&
      (this.state.cellphoneState === "success" || this.state.cellphoneState === "") &&
      (this.state.routingNumberState === "success" || this.state.routingNumberState === "") &&
      (this.state.accountNumberState === "success" || this.state.accountNumberState === "") &&
      this.state.selectedPlanState === "success" &&
      this.state.agreeState === "success"
    ) {
      return true;
    } else {
      if (this.state.firstNameState !== "success") {
        this.setState({ firstNameState: "error" });
      }
      if (this.state.lastNameState !== "success") {
        this.setState({ lastNameState: "error" });
      }
      if (this.state.emailState !== "success") {
        this.setState({ emailState: "error" });
      }
      if (this.state.selectedPlanState !== "success") {
        this.setState({ selectedPlanState: "error" });
      }
      if (this.state.agreeState !== "success") {
        this.setState({ agreeState: "error" });
      }
    }
    return false;
  }


  onSubmitRegistration(e) {
    e.preventDefault();
    if (this.isValidated()) {
      this.setState({
        registrationStatus: ''
      })
      if (this.state.agree === 'S' && this.state.cellphone === '') {
        alert('You have selected to send the agreement by text, but you did not enter a cell phone number. ' +
          'Please either enter a cell phone number or send the agreement by email')
      } else {

        this.setState({
          finishButtonDisabled: true,
          registrationStatus: 'registering',
          errorText: ''
        })
        var submitArray = [];


        var userInfoArray = {
          'username': this.state.email,
          'email': this.state.email,
          'firstname': this.state.firstName,
          'lastname': this.state.lastName,
          'pmsPatientId': this.state.pmsPatientId,
          'userType': 'patient',
          'parentId': this.state.parentPatientId,
          'parentOrgType': this.state.parentOrgType
        }

        var addressArray = {
          'address1': this.state.address1,
          'address2': this.state.address2,
          'addressCity': this.state.addressCity,
          'addressState': this.state.addressState,
          'addressZip': this.state.addressZip,
          'phone': this.state.phone,
          'cellphone': this.state.cellphone,
          'taxId': '',
          'taxClassification': ''

        }

        var selectedProviderId = ''
        if (this.state.selectedProviderId !== '') {
          selectedProviderId = this.state.selectedProviderId
        } else {
          selectedProviderId = this.state.providerId
        }

        var providerArray = { 'selectedProviderId': selectedProviderId, 'invitationCode': '' }

        var planArray = { 'selectedPlanId': this.state.selectedPlanId,
                          'selectedPlanType': this.state.selectedPlanType,
                          'selectedSavingsAmount': this.state.selectedSavingsAmount}

        var paymentArray = {
          'routingNumber': this.state.routingNumber,
          'accountNumber': this.state.accountNumber,
          'accountType': this.state.accountType,
          'paymentMethod': this.state.paymentMethod,
          'creditCardTxToken': this.state.creditCardTxToken,
          'creditCardProcessor': this.state.creditCardProcessor
        }
        var agreementArray = {
          'agree': this.state.agree,
          'fullAgreementViewed': this.state.fullAgreementViewed,
          'fileName': this.state.agreementFileName
        }

        submitArray['userInfo'] = userInfoArray;
        submitArray['address'] = addressArray;
        submitArray['provider'] = providerArray;
        submitArray['plan'] = planArray;
        submitArray['payment'] = paymentArray;
        submitArray['agreement'] = agreementArray;
        const submitData = {
          userInfo: JSON.stringify(submitArray['userInfo']),
          address: JSON.stringify(submitArray['address']),
          provider: JSON.stringify(submitArray['provider']),
          plan: JSON.stringify(submitArray['plan']),
          payment: JSON.stringify(submitArray['payment']),
          agreement: JSON.stringify(submitArray['agreement'])
        }
        if (this.state.registerAsChild === true) {
          axios.post(`${API_ROOT}/registerChild/`, submitData, { headers: getApiHeaders() })
            .then(res => this.handleRegistrationResponse(res));
        } else {
          axios.post(`${API_ROOT}/register/`, submitData, { headers: getApiHeaders() })
            .then(res => this.handleRegistrationResponse(res));
        }
      }
    } else {
      alert('Please enter the required information before registering the patient.')
    }
  }


  handleRegistrationResponse(res) {
    if (this._isMounted) {
      var updateMessage = '';
      var errorText = '';
      if (res.data.message.status === 'success') {
        updateMessage = "Registration complete.";
        errorText = ''
        if (this.props.postRegisterFunction) {
          this.props.postRegisterFunction()
        }
      } else {
        updateMessage = "There was an issue creating your account: ";
        updateMessage += res.data.message.status;
        updateMessage += ". ";
        updateMessage += "Please fix this issue and try again. ";
        updateMessage += "If you fix the issue and are still not able to register, please contact support.";
        errorText = "ERROR"
      }
      this.setState({
        finishButtonDisabled: false,
        registrationStatus: updateMessage,
        errorText: errorText
      })
    }
  }

  handleAgreementCheckbox(checkboxValue, fullAgreementViewed, agreementFileName) {
    var agreeState = ''
    if (checkboxValue === 1) {
      agreeState = 'success'
    }
    this.setState({
      agree: checkboxValue,
      agreeState: agreeState,
      fullAgreementViewed: fullAgreementViewed,
      agreementFileName: agreementFileName
    })
  }

  updateStateFromChild(stateName, value) {
    this.setState({ [stateName]: value });
  }

  lookUpProviderSettings() {
    axios.get(`${API_ROOT}/organizationInfo/?userId=` + this.state.providerId, { headers: getApiHeaders() })
      .then(res => this.setProviderSettings({ responseMessage: res.data }));
  }

  setProviderSettings(res) {
    if (this._isMounted) {
      if (!res.responseMessage.error) {
        if (res.responseMessage.acceptCreditCards) {
          this.lookupCreditCardProcessor()
        }
        this.setState({
          acceptCreditCards: false,
          allowMonthlyPlans: res.responseMessage.allowMonthlyPlans,
          allowAnnualPlans: res.responseMessage.allowAnnualPlans,
          chargeCreditCardFee: res.responseMessage.chargeCreditCardFee,
          creditCardFee: res.responseMessage.creditCardFee
        });
      }
    }
  }

  lookupCreditCardProcessor() {
    axios.get(`${API_ROOT}/connectedAccount/?userId=` + this.state.providerId + `&type=` + CREDIT_CARD_PROCESSOR + `&boolean=true`, { headers: getApiHeaders() })
      .then(res => this.setCreditCardProcessor(res.data));
  }

  setCreditCardProcessor(res) {
    if (res.status) {
      this.setState({
        acceptCreditCards: true
      });
    }
  }

  populatePatientData(patientData) {
    this.setState({
      firstName: patientData['firstName'],
      firstNameState: verifyLength(patientData['firstName'], nameLength) ? 'success' : 'error',
      lastName: patientData['lastName'],
      lastNameState: verifyLength(patientData['lastName'], nameLength) ? 'success' : 'error',
      address1: patientData['address1'],
      address2: patientData['address2'],
      addressCity: patientData['city'],
      addressState: patientData['state'],
      addressZip: patientData['zip'],
      addressZipState: !patientData['zip'] || patientData['zip'] === '' || verifyZip(patientData['zip']) ? 'success' : 'error',
      phone: formatPhoneNumber(patientData['phone']),
      phoneState: !patientData['phone'] || patientData['phone'] === '' || verifyPhone(patientData['phone']) ? 'success' : 'error',
      cellphone: formatPhoneNumber(patientData['cellPhone']),
      cellphoneState: !patientData['cellPhone'] || patientData['cellPhone'] === '' || verifyPhone(patientData['cellPhone']) ? 'success' : 'error',
      email: patientData['email'],
      emailState: verifyEmail(patientData['email']) ? 'success' : 'error',
      pmsPatientId: patientData['personId'],
      pmsSearchOpen: false
    });
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Dialog
          classes={{ paper: classes.dialogPaper }}
          open={this.state.pmsSearchOpen}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth='md'
          fullWidth={true}
        >
          <DialogTitle id="form-dialog-title">Search for a patient in your PMS</DialogTitle>
          <DialogContent>
            <PmsSearch
              providerId={this.state.providerId}
              populatePatientData={this.populatePatientData.bind(this)}
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={this.togglePmsSearchOpen.bind(this)} color="cirrusBlue">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <GridContainer>
          <GridItem xs={12} sm={12} md={8}>
            <form onSubmit={this.onSubmitRegistration}>
              <Card>
                <CardHeader color="cirrusBlue" icon style={this.state.asPopup ? { display: 'none' } : {}}>
                  <CardIcon color="cirrusBlue">
                    <Assignment style={this.state.asPopup ? { display: 'none' } : {}}/>
                  </CardIcon>
                  <h4 id="registerPatientHeader" className={classes.cardIconTitle}>
                    Register a Patient - <small>please complete the following information</small>
                  </h4>
                </CardHeader>
                <CardBody>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12} style={this.state.pmsIntegration ? {} : { display: 'none' }}>
                      <Button
                        round
                        onClick={this.togglePmsSearchOpen.bind(this)}
                        color="cirrusBlue"
                        id="openPmsSearchButton"
                      >
                        import from PMS
                      </Button>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        success={this.state.firstNameState === "success"}
                        error={this.state.firstNameState === "error"}
                        labelText={
                                    <span>
                                      first name <small>(required)</small>
                                    </span>
                                    }
                        id="firstName"
                        formControlProps={{
                          fullWidth: true,
                          margin: this.state.formControlMargin
                        }}
                        inputProps={{
                          onChange: event => this.change(event, "firstName", "length", nameLength),
                          value: this.state.firstName,
                          disabled: this.state.inputDisabled
                        }}
                        customStyle={this.state.customInputStyle}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        success={this.state.lastNameState === "success"}
                        error={this.state.lastNameState === "error"}
                        labelText={
                                    <span>
                                      last name <small>(required)</small>
                                    </span>
                                    }
                        id="lastName"
                        formControlProps={{
                          fullWidth: true,
                          margin: this.state.formControlMargin
                        }}
                        inputProps={{
                          onChange: event => this.change(event, "lastName", "length", nameLength),
                          value: this.state.lastName,
                          disabled: this.state.inputDisabled
                        }}
                        customStyle={this.state.customInputStyle}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>

                      <CustomInput
                        labelText="address"
                        id="address1"
                        formControlProps={{
                          fullWidth: true,
                          margin: this.state.formControlMargin
                        }}
                        inputProps={{
                          onChange: event => this.change(event, "address1"),
                          value: this.state.address1,
                          disabled: this.state.inputDisabled
                        }}
                        customStyle={this.state.customInputStyle}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="address"
                        id="address2"
                        formControlProps={{
                          fullWidth: true,
                          margin: this.state.formControlMargin
                        }}
                        inputProps={{
                          onChange: event => this.change(event, "address2"),
                          value: this.state.address2,
                          disabled: this.state.inputDisabled
                        }}
                        customStyle={this.state.customInputStyle}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                      <CustomInput
                        labelText="city"
                        id="addressCity"
                        formControlProps={{
                          fullWidth: true,
                          margin: this.state.formControlMargin
                        }}
                        inputProps={{
                          onChange: event => this.change(event, "addressCity"),
                          value: this.state.addressCity,
                          disabled: this.state.inputDisabled
                        }}
                        customStyle={this.state.customInputStyle}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>


                      <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                      >
                        <InputLabel
                          htmlFor="simple-select"
                          className={classes.selectLabel}
                        >
                          state
                        </InputLabel>
                        <Select
                          MenuProps={{
                            className: classes.selectMenu
                          }}
                          classes={{
                            select: classes.select
                          }}
                          value={this.state.addressState}

                          inputProps={{
                            onChange: event => this.change(event, "addressState"),
                            id: "addressState",
                            name: "addressState",
                            disabled: this.state.inputDisabled

                          }}

                        >
                          <MenuItem
                            disabled
                            classes={{
                              root: classes.selectMenuItem
                            }}
                          >
                            Choose state
                          </MenuItem>
                          {usStateList.map((usState) =>
                            <MenuItem classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected
                            }} key={usState.abbreviation} value={usState.abbreviation} >{usState.name}</MenuItem>
                          )}

                        </Select>
                      </FormControl>

                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <CustomInput
                        success={this.state.addressZipState === "success"}
                        error={this.state.addressZipState === "error"}
                        labelText="ZIP Code"
                        id="addressZip"
                        formControlProps={{
                          fullWidth: true,
                          margin: this.state.formControlMargin
                        }}
                        inputProps={{
                          onChange: event => this.change(event, "addressZip", "zip", '', true),
                          value: this.state.addressZip,
                          disabled: this.state.inputDisabled
                        }}
                        customStyle={this.state.customInputStyle}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>

                      <CustomInput
                        success={this.state.emailState === "success"}
                        error={this.state.emailState === "error"}
                        labelText={
                                    <span>
                                      email <small>(required)</small>
                                    </span>
                                  }
                        id="email"
                        formControlProps={{
                          fullWidth: true,
                          margin: this.state.formControlMargin
                        }}
                        inputProps={{
                          onChange: event => this.change(event, "email", "email", '9'),
                          value: this.state.email,
                          disabled: this.state.inputDisabled
                        }}
                        customStyle={this.state.customInputStyle}
                      />
                      <p id="usernameStatusMessage">
                        {this.state.usernameStatusMessage}
                      </p>
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        success={this.state.phoneState === "success"}
                        error={this.state.phoneState === "error"}
                        labelText="phone"
                        id="phone"
                        formControlProps={{
                          fullWidth: true,
                          margin: this.state.formControlMargin
                        }}
                        inputProps={{
                          onChange: event => this.change(event, "phone", "phone", '', true),
                          value: this.state.phone,
                          disabled: this.state.inputDisabled
                        }}
                        customStyle={this.state.customInputStyle}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        success={this.state.cellphoneState === "success"}
                        error={this.state.cellphoneState === "error"}
                        labelText="cell phone"
                        id="cellphone"
                        formControlProps={{
                          fullWidth: true,
                          margin: this.state.formControlMargin
                        }}
                        inputProps={{
                          onChange: event => this.change(event, "cellphone", "phone", '', true),
                          value: this.state.cellphone,
                          disabled: this.state.inputDisabled
                        }}
                        customStyle={this.state.customInputStyle}
                      />
                    </GridItem>
                  </GridContainer>
                </CardBody>
                <CardHeader color="cirrusBlue" icon style={this.state.viewType !== 'employer' ? {} : { display: 'none' }}>
                  <h4 className={classes.cardIconTitle}>
                    Bank Information - <small>enter the patient's bank details</small>
                  </h4>
                </CardHeader>
                <CardBody style={this.state.viewType !== 'employer' ? {} : { display: 'none' }}>
                  <Payment
                    embedded={true}
                    submitAction={'saveNoReload'}
                    userId={this.state.parentPatientId}
                    acceptCreditCards={this.state.acceptCreditCards}
                    updateParentState={this.updateStateFromChild.bind(this)}
                    inRegistration={true}
                    inDialog={this.state.inDialog}
                    chargeCreditCardFee = {this.state.chargeCreditCardFee}
                    creditCardFee = {this.state.creditCardFee}
                  />
                </CardBody>

                      <Subscriptions
                        providerId={this.state.providerId}
                        editByOrg={this.state.editByOrg}
                        cardTitle='Select Subscription'
                        cardSubtitle='choose the subscription for the patient (required)'
                        showCardIcon={false}
                        saveSelection={false}
                        onSelectPlan={this.selectPlan.bind(this)}
                        onSelectSavingsAmount={this.selectSavingsAmount.bind(this)}
                        standardSelectText={true}
                        employerId={this.state.employerId}
                        allowMonthlyPlans={this.state.allowMonthlyPlans}
                        allowAnnualPlans={this.state.allowAnnualPlans}
                        getMemberPlanInfo={this.state.getMemberPlanInfo}
                        chargeCreditCardFee={this.state.chargeCreditCardFee}
                        creditCardFee={this.state.creditCardFee}
                        paymentMethod={this.state.paymentMethod}
                      />

                <CardHeader color="cirrusBlue" icon>
                  <h4 className={classes.cardIconTitle}>
                    User Agreement - <small>{this.state.userAgreementSubheader}</small>
                  </h4>
                </CardHeader>
                <span style={this.state.asPopup && this.state.viewType !== 'employer' && this.state.actorOrgType === 'patient' ? {} : { display: 'none' }}>
                  <Agreement
                    signOnBehalfOfChildMember = {true}
                    handleCheckbox = {this.handleAgreementCheckbox.bind(this)}

                  />
                </span>
                <CardBody>
                  <GridContainer style={this.state.actorOrgType === 'patient' ? { display: 'none' } : {}}>
                    <GridItem xs={12} sm={8}>
                      <FormControlLabel
                        control={
                          <Radio
                            checked={this.state.agree === "E"}
                            onChange={event => this.change(event, "agree", "exists")}
                            value="E"
                            name="agree"
                            aria-label="E"
                            icon={
                              <FiberManualRecord
                                className={classes.radioUnchecked}
                              />
                            }
                            checkedIcon={
                              <FiberManualRecord
                                className={classes.radioChecked}
                              />
                            }
                            classes={{
                              checked: classes.radio,
                              root: classes.radioRoot
                            }}
                          />
                        }
                        classes={{
                          label: classes.label
                        }}
                        label="email"
                      />
                    </GridItem>
                    <GridItem xs={12} sm={8}>
                      <FormControlLabel
                        control={
                          <Radio
                            checked={this.state.agree=== "S"}
                            onChange={event => this.change(event, "agree", "exists")}
                            value="S"
                            name="agree"
                            aria-label="S"
                            icon={
                              <FiberManualRecord
                                className={classes.radioUnchecked}
                              />
                            }
                            checkedIcon={
                              <FiberManualRecord
                                className={classes.radioChecked}
                              />
                            }
                            classes={{
                              checked: classes.radio,
                              root: classes.radioRoot
                            }}
                          />
                        }
                        classes={{
                          label: classes.label
                        }}
                        label="text message"
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={12}>
                      <Button id="registerPatientButton" color="cirrusBlue" className={classes.updateProfileButton} type="submit" disabled={this.state.finishButtonDisabled}>
                        register
                      </Button>
                    </GridItem>
                    <GridItem xs={12} sm={12}>
                      <Danger>{this.state.errorText}</Danger>
                      <span id="registrationStatus">{this.state.registrationStatus}</span>
                      <Clearfix />
                    </GridItem>
                  </GridContainer>
                </CardBody>
              </Card>
            </form>
          </GridItem>
        </GridContainer>
      </div>
    )

  }


}

export default withStyles(style)(RegisterPatient);
